export enum JobRepairPhotoTypeEnum {
  'Photo' = 'Photo',
  'Screenshot' = 'Screenshot',
}
